module.exports = __webpack_public_path__ + "img/net.94ec24dd.png";